import React from 'react';
import { compose } from 'recompose';
import { reduxForm } from 'redux-form';
import { validateContactOriginSettings } from 'common/formValidation/settings';
import Dropdown from 'components/Dropdown';
import { PATCH } from '../../../../utils/httpMethods';
import FormFieldsWhitoutFooter from '../../FormFieldsWhitoutFooter';
import ContactOriginList from '../various/ContactOriginList';

import '../SaveButton.css';

const submitContactOrigin = ({ global: { contactOriginTypes } }) => PATCH('/api/settings/contactOriginTypes', { body: { contactOriginTypes } });

const ContactOriginInner = (props) => (
    <FormFieldsWhitoutFooter {...props} back="/admin/settings">
        <Dropdown title="Origine du contact">
            <ContactOriginList />
            <div className="submit" style={{ marginBottom: '15px' }}>
                <button className="sendSettingsButton" type="submit">
                    Enregistrer
                </button>
            </div>
        </Dropdown>
    </FormFieldsWhitoutFooter>
);

const ContactOriginForm = compose(reduxForm({
    form: 'entity-settings-contactOrigin-edit',
    enableReinitialize: true,
    validate: validateContactOriginSettings,
}))(ContactOriginInner);

// onSubmit du parent (settings d'entité) est volontairement écrasé
const ContactOrigin = (props) => <ContactOriginForm {...props} onSubmit={submitContactOrigin} />;

export default ContactOrigin;
